import AcceptHealthClaimModal from './AcceptHealthClaimModal'

export default AcceptHealthClaimModal
